import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import Styles from '../../Css/UploadScreen.module.css'
import styles from '../../Css/CustomSettings.module.css'
import '../../Css/Common.css'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import BackgroundListModal from '../Modals/BackgroundListModal'
import CustomSettings from './CustomSettings'
import ImageSectionBulk from './ImageSectionBulk'
import Dropzone from 'react-dropzone'
import { ContextConsumer, AuthContext } from '../../context/GlobalState'
import { delay } from "q"
import alertify from 'alertifyjs'
import 'alertifyjs/build/css/alertify.css';
import ProjectNameModal from '../Modals/ProjectNameModal'
import BulkCreditModal from '../Modals/BulkCreditModal'
import { fetchCreditUserDetails, updateUserCredit, cookie, poll, chunkArrayWhiteoutCorrection } from '../Common/Utils'
import DownloadScreenBulk from './DownloadScreenBulk'
import UploadLimitModal from '../Modals/UploadLimitModal'
import RefundModal from '../Modals/RefundModal';


function BulkImageProcessing(props) {

    const cookie = key => ((new RegExp((key || '=') + '=(.*?); ', 'gm')).exec(document.cookie + '; ') || ['', null])[1]

    const [backgroundId, setBackgroundId] = useState('')
    const [checkWindowTransparency, setCheckWindowTransparency] = useState(false)
    const [checkColorEnhancement, setCheckColorEnhancement] = useState(false)
    const [checkBlurNumberPlate, setCheckBlurNumberPlate] = useState(false)
    const [checkWindowCorrection, setCheckWindowCorrection] = useState(true)
    const [selectedLogoFile, setSelectedLogoFile] = useState(null)
    const [isSolidBackgrounds, setisSolidBackgrounds] = useState(false)
    const [bgList, setBgList] = useState([])
    const [favBgList, setFavBgList] = useState([])
    const [bgCredit, setBgCredit] = useState(null)
    const [showBackgroundList, setShowBackgroundList] = useState(false)
    const [toggleStatus, setToggleStatus] = useState(window.localStorage.getItem(`fileList`) ? true : false)
    const [isDelearshipLogo, setIsDelearshipLogo] = useState(false)
    const [numberPlate, setNumberPlate] = useState(null)
    const [isBackgroundBlur, setIsBackgroundBlur] = useState(false)
    const [isImageHide, setIsImageHide] = useState(JSON.parse(window.sessionStorage.getItem(`isImageHide`)) ? JSON.parse(window.sessionStorage.getItem(`isImageHide`)) : false)
    const [angle, setAngle] = useState('')
    const [colorList, setColorList] = useState([])
    const [marketPlaceList, setMarketPlaceList] = useState([])
    const [marketId, setMarketId] = useState(null)
    const [bgColorCode, setBgColorCode] = useState('')
    const [bgUrl, setbgUrl] = useState('')
    const [checkShadow, setCheckShadow] = useState(false)
    const [modelData, setModelData] = useState([])
    const [modelId, setModelId] = useState(null)
    const [modelPose, setModelPose] = useState([])
    const [poseToDisplay, setPoseToDisplay] = useState([])
    const [applyType, setApplyType] = useState('VS')
    const [customWall, setCustomWall] = useState('')
    const [wallData, setWallData] = useState([])
    const [applyWay, setApplyWay] = useState('')
    const [checkBodyReflection, setCheckBodyReflection] = useState(false)
    const [checkBrightness, setCheckBrightness] = useState("1")
    const [checkTint, setCheckTint] = useState("0")
    const [checkBlur, setCheckBlur] = useState("")
    const [skuName, setSkuName] = useState(window.sessionStorage.getItem("sku_name") ? window.sessionStorage.getItem("sku_name") : '')
    const [projectName, setProjectName] = useState(window.sessionStorage.getItem("project_name") ? window.sessionStorage.getItem("project_name") : '')
    const [showProjectNameModal, setShowProjectNameModal] = useState(false)
    const [projectNameExists, setProjectNameExists] = useState(false)
    const [refundImgUrl, setRefundImgUrl] = useState('')
    const [refundOrgUrl, setRefundOrgUrl] = useState('')
    const [showRefundModal, setShowRefundModal] = useState(false)
    const [refundImgId, setRefundImgId] = useState('')
    const [refundSkuId, setRefundSkuId] = useState('')
    const [refundNum, setRefundNum] = useState(null)
    const [uploadStarted, setUploadStarted] = useState(window.sessionStorage.getItem(`${props.random}uploadStarted`) ? window.sessionStorage.getItem(`${props.random}uploadStarted`) : false)
    const [showBulkCreditModal, setShowBulkCreditModal] = useState(false)
    const [enoughCreditModal, setEnoughCreditModal] = useState(false)
    const [notEnoughCreditModal, setNotEnoughCreditModal] = useState(false)
    const [zeroCreditModal, setZeroCreditModal] = useState(false)
    const [batchFiles, setBatchFiles] = useState([])
    const [isZipReady, setIsZipReady] = useState(window.sessionStorage.getItem("isZipReady") ? window.sessionStorage.getItem("isZipReady") : false)
    const [chargedFeature, setChargedFeature] = useState(0)
    const [bulkDownloadDone, setBulkDownloadDone] = useState(window.sessionStorage.getItem(`${props.random}bulkDownloadDone`) ? window.sessionStorage.getItem(`${props.random}bulkDownloadDone`) : false)
    const [userId, setUserId] = useState('')
    const [authKey, setAuthKey] = useState('')
    const [emailId, setEmailId] = useState('')
    const [spinnerDownload, setspinnerDownload] = useState(false)
    const [downloadZipLink, setDownloadZipLink] = useState(window.sessionStorage.getItem(`${props.random}downloadZipLink`) ? window.sessionStorage.getItem(`${props.random}downloadZipLink`) : '')
    const [isDisSatisfied, setIsDisSatisfied] = useState(false)
    const [imageSectionModalImage,setImageSectionModalImage] = useState(null)
    const [shadowType, setShadowType] = useState("soft")
    const [applyShadow,setApplyShadow] = useState(true)
    const [seeThrough, setSeeThrough] = useState(false)
    const [isEditingStart,setIsEditingStart] = useState(false)
    const [isEditingFinish, setIsEditingFinish] = useState(window.sessionStorage.getItem("isEditingFinish") ? window.sessionStorage.getItem("isEditingFinish") :false)



    const context = useContext(AuthContext)

    const handleCheckShadow = () => {
        setCheckShadow(!checkShadow)
    }

    useEffect(() => {

        let userEmail = cookie("emailId")
        let userId = cookie("userId")

        let url = window.location.pathname
        let bgAngles

        if (url.includes("food")) {
            bgAngles = 0
            setAngle(0)
        } else {
            bgAngles = ''
        }
        fetchBackground(bgAngles)
        fetchMarketPlace()
        
        if (userId && userEmail && context.auth.loggedIn) {
            setIsImageHide(false)
            window.sessionStorage.setItem(`isImageHide`, false)
        }
        setShowProjectNameModal(true)
        setUserId(cookie('userId'))
        setEmailId(cookie('emailId'))
        setAuthKey(cookie('auth_token'))
    }, [])


    const bulkImageProcessing = async (i) => {
        let auth_token = cookie('auth_token')
        let enterprise_id = cookie('enterpriseId')
        setToggleStatus(!toggleStatus)
        window.sessionStorage.setItem(`isImageHide`, true)
        console.log('meri image',props.fileList[i].file);

        const fd = new FormData();
        fd.append("background_id", backgroundId);
        fd.append("window_status", checkWindowTransparency ? 'inner' : 'outer');
        fd.append("is_color", checkColorEnhancement);
        fd.append("number_plate_blur", checkBlurNumberPlate);
        fd.append("window_correction", checkWindowCorrection)
        fd.append("prod_cat_id", props.prodCatId)
        fd.append("auth_key", auth_token)
        fd.append("prod_sub_cat_id", "")
        fd.append("enterprise_id", enterprise_id)
        fd.append('processing_type', 'REALTIME')
        fd.append('source', 'BULKPROCESS')
        fd.append("wall_url", "0");
        fd.append("apply_type", "VS")
        fd.append("category", props.subCatName)
        fd.append('frame_seq_no', i)
        fd.append("sku_name", skuName)
        fd.append("project_name", projectName)
        fd.append("image", props.fileList[i].file)
        fd.append('body_reflection', checkBodyReflection ? 1 : 0)
        fd.append('window_tint', checkTint)
        fd.append('brightness', checkBrightness)
        fd.append("bg_url", bgUrl)
        fd.append("bg_color", bgColorCode)
        fd.append("wall_effect", checkShadow ? 'True' : 'False')
        fd.append('see_through',seeThrough)
        fd.append('seat_generation',checkWindowCorrection)
        if (selectedLogoFile !== null) {
            fd.append("logo_number_plate", selectedLogoFile);
        }
        if (props.fileList.length - 1 === i) {
            fd.append("last_image", true)
        } else {
            fd.append("last_image", false)
        }
        if(props.prodCatId === "cat_skJ7HIvnc" && applyShadow === true){
            fd.append("shadow_type","hard")
            fd.append("apply_shadow",applyShadow)
            
        }
        return axios.post(`${process.env.REACT_APP_BASEURL}/v2/self-serve/image-process`,fd)
        // return axios.post(`http://localhost:5000/api/v2/self-serve/image-process`, fd)
            .then((resp) => {
                if (resp.data.status === 'Done') {
                    props.handleBulkApiResponse(resp?.data, i)
                    setIsEditingFinish(true)
                    return Promise.resolve(resp)
                } else {
                    alertify.error('Image Failed Due To Server Error!!!');
                    props.handleErrorApiResponse(resp, i)
                    setIsEditingFinish(true)
                    return Promise.reject(resp)
                }
            })
            .catch((err) => {
                props.handleErrorApiResponse(err, i)
                return Promise.reject(err)

            })
    }

    const hitUploadAPI = async () => {

        let price = props.fileList.length

        if (props.availableCredit >= price) {
            props.getUserCredit()

            setUploadStarted(true)
            setShowBulkCreditModal(false)
            setEnoughCreditModal(false)
            setBatchFiles(chunkArrayWhiteoutCorrection(props.fileList, 4))

            let tempBatchFile = chunkArrayWhiteoutCorrection(props.fileList, 4)


            for (let batchIndex = 0; batchIndex < tempBatchFile.length; batchIndex++) {

                try {
                    const resp = await Promise.allSettled(tempBatchFile[batchIndex].map(async (file, currIndex) => {
                        if (batchIndex === 0) {
                            let i = 1 * batchIndex + currIndex
                            return await bulkImageProcessing(i)
                        }
                        else {
                            let i = 4 * batchIndex - 3 + currIndex
                            return await bulkImageProcessing(i)
                        }
                    }))
                } catch (err) {
                    alertify.error("Some of the images failed due to server error.")
                }
            }
            setIsZipReady(true)

            updateUserTransactions()

            sessionStorage.setItem(`${props.random}isZipReady`, true);
            window.sessionStorage.setItem(`isImageHide`, false)

            sessionStorage.setItem(`${props.random}uploadStarted`, true);

        } else if (props.availableCredit < price) {
            // const fileListNew = this.state.fileList.slice(0,this.state.availableCredit)
            // this.forceUpdate()
            setUploadStarted(true)
            setShowBulkCreditModal(false)
            setNotEnoughCreditModal(false)
            sessionStorage.setItem(`${props.random}uploadStarted`, true);


            setBatchFiles(chunkArrayWhiteoutCorrection(props.fileList, 4))

            for (let batchIndex = 0; batchIndex < batchFiles.length; batchIndex++) {

                try {
                    const resp = await Promise.allSettled(batchFiles[batchIndex].map(async (file, currIndex) => {
                        if (batchIndex === 0) {
                            let i = 1 * batchIndex + currIndex
                            return await bulkImageProcessing(i)
                        }
                        else {
                            let i = 4 * batchIndex - 3 + currIndex
                            return await bulkImageProcessing(i)
                        }
                    }))
                } catch (err) {
                    alertify.error("Something Went Wrong! please try again.")
                }
            }
            setIsZipReady(true)
            window.sessionStorage.setItem(`isImageHide`, false)

            updateUserTransactions()

            sessionStorage.setItem(`${props.random}isZipReady`, true);

            let arr = props.fileList.slice(0, props.availableCredit)
            // this.setState({
            //     fileList : [...arr]
            // }, () => {
            //     console.log(this.state.fileList.length)
            // })


        }


    }


    const creditVerify = () => {
        let importantParameters = [backgroundId,bgUrl,bgColorCode];
        let pass = true
        for(let i=0;i<importantParameters.length;i++){
            if(importantParameters[i]){
                break;
            }
            if(i+1 === importantParameters.length)
            {
                pass = false;
            }
        }
        if(!pass){
            alertify.error('No background selected')
            return;
        }
        
        setShowBackgroundList(false)
        setIsEditingStart(true)
        let price = (1 + chargedFeature) * props.fileList.length
        if (props.availableCredit >= price) {

            setShowBulkCreditModal(true)
            setNotEnoughCreditModal(false)
            setZeroCreditModal(false)
            setEnoughCreditModal(true)


        } else if (props.availableCredit === 0) {
            setShowBulkCreditModal(true)
            setZeroCreditModal(true)
        } else if (props.availableCredit < price) {

            setShowBulkCreditModal(true)
            setNotEnoughCreditModal(true)
            props.removeExtraImagesFromList()


            // this.setState({
            //     showBulkCreditModal: true,
            //     notEnoughCreditModal:true,
            //     fileList : this.state.fileList.slice(0,this.state.availableCredit)

            // })
        }
    }

    const updateUserTransactions = () => {
        let auth_key = cookie("auth_token")
        const fd = new FormData()
        let available_credits_after = props.beforeCredits - props.fileList.length
        fd.append("auth_key", auth_key);
        fd.append("sku_id", props.fileList[0].skuId);
        fd.append("processing_source", "BULKPROCESS");
        fd.append("available_credits_before", props.beforeCredits)
        fd.append("image_count", props.fileList.length)
        fd.append("available_credits_after", available_credits_after)
        axios.post(`${process.env.REACT_APP_BASEURL}/v2/transactions/insert`, fd)
            .then(resp => {
                // if(resp.data.status == 200){
                //     console.log(resp)
                // }
            })
    }

    const downloadImages = () => {
        setspinnerDownload(true)

        axios({
            method: "GET",
            url: `${process.env.REACT_APP_BASEURL}/v2/download/sku`,
            params: {
                sku_id: props.fileList[0].skuId,
                auth_key: cookie("auth_token"),
            }
        })
            .then(resp => {

                setDownloadZipLink(resp?.data?.data?.zip_file_url)
                const a = document.createElement("a")
                a.href = resp?.data?.data?.zip_file_url
                a.download = true
                a.click()
                sessionStorage.setItem(`${props.random}downloadZipLink`, resp?.data?.data?.zip_file_url)
                setspinnerDownload(false)
                setBulkDownloadDone(true)
                sessionStorage.setItem(`${props.random}bulkDownloadDone`, true)
            })
    }
    const handleBulkCreditModal = () => {
        setShowBulkCreditModal(false)
    }

   




    const fetchMarketPlace = () => {
        let auth_key = cookie('auth_token')
        let auth_token
        if (auth_key) {
            auth_token = auth_key
        } else {
            auth_token = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        }
        let enterpriseId = cookie('enterpriseId')
        const data = new FormData();
        data.append("auth_key", auth_token)
        data.append("prod_cat_id", props.prodCatId)
        data.append("enterprise_id", enterpriseId)
        axios({
            'method': "POST",
            'url': process.env.REACT_APP_BASEURL + `/v2/self-serve/get-category-market-place`,
            'data': data,

        })
            .then((res) => {
                setMarketPlaceList(res?.data?.data?.market_place_list)
            })
    }

    const fetchBackground = (angles) => {
        let auth_key = cookie('auth_token')
        let enterpriseId = cookie('enterpriseId')
        const data = new FormData();
        let bg_angles
        if (angles === '') {

            bg_angles = angle
        } else {
            bg_angles = angles
        }
        data.append("auth_key", auth_key)
        data.append("prod_cat_id", props.prodCatId)
        data.append("enterprise_id", enterpriseId)
        data.append("angle", bg_angles)
        axios({
            'method': "POST",
            'url': process.env.REACT_APP_BASEURL + `/v2/self-serve/get-category-bg`,
            'data': data,

        })
            .then((res) => {

                setBgList(res?.data?.data?.spynelist)
                setFavBgList(res?.data?.data?.favList)
                setColorList(res?.data?.data?.color_walls)
            })
    }




    const set_modelId = async (model_id, pose) => {
        setModelId(model_id);
        setModelPose(pose);
        setPoseToDisplay([])
    }
    const add_poses = (input) => {
        if (poseToDisplay.indexOf(input) > -1) {
            setPoseToDisplay(poseToDisplay => {
                let fromIndex = poseToDisplay.indexOf(input);
                let temp = poseToDisplay.filter((e) => {
                    if (e !== input)
                        return true
                })
                return temp
            })
        }
        else {
            setPoseToDisplay([...poseToDisplay, input])
        }


    }

    const handleColorBackground = (imageId, code, url) => {
        setBackgroundId(imageId)
        setBgColorCode(code)
        setbgUrl(url)
        setBgCredit(null)
    }

    const handleBackground = (imageId, imageCredit, bgUrl) => {
        setBgColorCode('')
        setBackgroundId(imageId)
        setBgCredit(imageCredit)
        setbgUrl(bgUrl)
    }

    const handleMarketId = (Id) => {
        setMarketId(Id)
    }

    const handleBackgroundList = () => {
        setShowBackgroundList(!showBackgroundList)
    }

    const hideList = () => {
        setShowBackgroundList(!showBackgroundList)
    }

    const handleToggleImage = () => {
        let userEmail = cookie("emailId")
        let userId = cookie("userId")
        setToggleStatus(!toggleStatus)
        if (!userId && !userEmail && !context.auth.loggedIn) {
            if (toggleStatus) {
                setIsImageHide(false)
            } else {
                setIsImageHide(true)
            }

        } else {
            setIsImageHide(false)
        }
        if (bgList.length === 0 && favBgList.length === 0 && !(props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing')) {
            let bgAngles = ''
            fetchBackground(bgAngles)
            fetchMarketPlace()
        }
    }

    const handleCarsFavList = async (i, image_id) => {

        const fd = new FormData()
        let auth_key = cookie('auth_token')
        // fd.append("auth_key", auth_key)
        fd.append("auth_key", auth_key)
        fd.append("background_id", image_id)
        fd.append("favourable", "false")
        fd.append("primary", "false")
        fd.append("prod_cat_id", props.prodCatId)
        await axios({
            'method': "POST",
            // 'url':`${process.env.REACT_APP_BASEURL}/v2/backgrounds/updatefavbg`,
            'url': process.env.REACT_APP_BASEURL + `/v2/self-serve/updatefavbg-self-serve`,

            "data": fd
        })
            .then((res) => {
                if (res.data.status === 200) {
                    // let sliced= favBgList.splice(i,1)
                    // bgList.unshift(sliced[0])
                    // setFavBgList(favBgList)
                    // setBgList(bgList)
                    let angles = ''
                    fetchBackground(angles)
                }
            })
    }

    const handleCarsBgList = async (i, image_id) => {
        const fd = new FormData()
        let auth_key = cookie('auth_token')
        fd.append("auth_key", auth_key)

        fd.append("background_id", image_id)
        fd.append("favourable", "true")
        fd.append("primary", "false")
        fd.append("prod_cat_id", props.prodCatId)

        await axios({
            'method': "POST",
            // 'url':`${process.env.REACT_APP_BASEURL}/v2/backgrounds/updatefavbg`,
            'url': process.env.REACT_APP_BASEURL + `/v2/self-serve/updatefavbg-self-serve`,

            "data": fd
        })
            .then((res) => {
                if (res.data.status === 200) {
                    // let sliced=bgList.splice(i,1)
                    // favBgList.unshift(sliced[0])
                    // setFavBgList(favBgList)
                    // setBgList(bgList)
                    let angles = ''
                    fetchBackground(angles)
                }

            })
    }

    const handleNumberPlate = (e) => {
        setNumberPlate(e)
        if (e === 'blur') {
            setCheckBlurNumberPlate(true)
        } else {
            setCheckBlurNumberPlate(false)
        }
    }

    const handleWindowCorrection = () => {
        setCheckWindowCorrection(!checkWindowCorrection)
    }

    const handleColorEnhancement = () => {
        setCheckColorEnhancement(!checkColorEnhancement)
    }

    const handleAngle = (angle) => {
        setAngle(angle)
        fetchBackground(angle)
    }

    const handleNumberPlateLogo = (blob) => {
        setSelectedLogoFile(blob)
    }

    const handleProjectNameModal = () => {
        let auth_key = cookie("auth_token")
        let user_id = cookie("userId")
        const fd = new FormData()
        fd.append("auth_key", auth_key);
        fd.append("user_id", user_id);
        fd.append("enterprise_id", "TaD1VC1Ko");
        fd.append("project_name", projectName)
        axios.post(`${process.env.REACT_APP_BASEURL}/v2/project/verify-project`, fd)
            .then((resp) => {
                if (resp.data.status === 404) {
                    setShowProjectNameModal(false)
                    setProjectNameExists(false)
                } else if (resp.data.status === 200) {
                    setProjectNameExists(true)
                }
            })
            .catch((err) => {
                alertify.error('Something went wrong')
            })

    }
    const handleProjectName = (e) => {
        e.preventDefault()
        const value = e.target.value;
        const regex = /^[0-9a-zA-Z]+$/; //this will admit letters & numbers 
        if (value.match(regex) || value === "") {
            setProjectName(value)
            setSkuName(value)
            setProjectNameExists(false)

        }

        sessionStorage.setItem("project_name", value);
        sessionStorage.setItem("sku_name", value);

    }
    const getRefundModal = (i) => {
        setRefundImgUrl(props.fileList[i].outputImgUrl)
        setShowRefundModal(true)
        setRefundOrgUrl(props.fileList[i].url)
        setRefundImgId(props.fileList[i].imageId)
        setRefundSkuId(props.fileList[i].skuId)
        setRefundNum(i)

    }
    const handleRefundModal = () => {
        setShowRefundModal(false)
    }

    const handleImageModalInImageSection = (image_url,isOpen) => {
        // create a state here, pass the state in image section.
        // pass this fn to virtual studio 
        isOpen ? setImageSectionModalImage(image_url) : setImageSectionModalImage(null)
    }

    const handleShadowType = (shadow_type) => {
        
        if(applyShadow){
            setShadowType(shadow_type)
        }else{
            setShadowType(null)
        }
        
    }

    return (

        <Dropzone onDrop={acceptedFiles => props.fileUpload(acceptedFiles)} onDragEnter={props.dragStart} onDragLeave={props.dragLeave}>
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps({
                    onClick: event => event.stopPropagation()
                })} className={Styles['dropzone-main']}>
                    {props.dropBackground ?
                        <section className={[Styles['drop-box-text']]}>
                            <div>Drop Image Anywhere</div>

                        </section>
                        : null
                    }

                    <div>
                        {/* Upload Automobile Photo Optmizer */}
                        <section className={[styles['upload-screen'], 'upload-screen'].join(' ')}>
                            <div className={[styles[''], 'container-common'].join(' ')}>
                                <div className={[styles[''], 'row'].join(' ')}>
                                    <div className={[styles['left-image-part'], 'col-md-6 left-image-part'].join(' ')}>
                                        <ul>
                                            <li><p><img src="https://storage.googleapis.com/spyne-website/self-serve/credit-blue.png" />
                                                {props.availableCredit === 0 ?
                                                    <span onClick={props.handleModal}> Get Free Credits</span>
                                                    :
                                                    <a className={[styles['credit-wallent-link']]} href="https://www.spyne.ai/tech/pricing" target="_blank"><span>{props.availableCredit} Credits</span></a>
                                                }

                                            </p>
                                            </li>
                                            {props.subCatName !== 'suit' && props.subCatName !== 'bedsheet' ?
                                                <Dropzone onDrop={acceptedFiles => props.fileUpload(acceptedFiles)} >
                                                    {({ getRootProps, getInputProps }) => (

                                                        <li {...getRootProps({})}><p><img src="https://storage.googleapis.com/spyne-website/self-serve/upload-blue.png" /> <span> Upload New Project</span></p>
                                                            <input onChange={props.fileUpload} type="file" {...getInputProps()} />
                                                        </li>
                                                    )}
                                                </Dropzone>
                                                :
                                                <li onClick={props.fileUpload}><p><img src="https://storage.googleapis.com/spyne-website/self-serve/upload-blue.png" /> <span> Upload New Project</span></p>
                                                </li>
                                            }
                                        </ul>
                                        <ImageSectionBulk
                                            handleToggleImage={handleToggleImage}
                                            toggleStatus={toggleStatus}
                                            isEditingStart={isEditingStart}
                                            fileList={props.fileList}
                                            random={props.random}
                                            multipleFileUpload={props.multipleFileUpload}
                                            updateMultipleImageList={props.updateMultipleImageList}
                                            uploadStarted={uploadStarted}
                                            isDisSatisfied={isDisSatisfied}
                                            getRefundModal={getRefundModal}
                                            imageSectionModalImage = {imageSectionModalImage}
                                            isEditingFinish={isEditingFinish}
                                        />
                                    </div>
                                    {/* Image Upload Area End  */}

                                    {/* Right Section */}

                                    {toggleStatus || isZipReady ?
                                        <div className={[styles['right-content-part'], 'col-md-6 right-content-part'].join(' ')}>
                                            <DownloadScreenBulk
                                                downloadImages={downloadImages}
                                                isZipReady={isZipReady}
                                                isDisSatisfied={isDisSatisfied}
                                                setIsDisSatisfied={setIsDisSatisfied}
                                                downloadZipLink={downloadZipLink}
                                            />
                                        </div>
                                        :
                                        <div className={[styles['right-content-part'], 'col-md-6 right-content-part'].join(' ')}>
                                            <CustomSettings
                                                fileList={props.fileList}
                                                isSolidBackgrounds={isSolidBackgrounds}
                                                favBgList={favBgList}
                                                backgroundId={backgroundId}
                                                handleBackground={handleBackground}
                                                handleCarsFavList={handleCarsFavList}
                                                handleBackgroundList={handleBackgroundList}
                                                bgList={bgList}
                                                colorList={colorList}
                                                handleCarsBgList={handleCarsBgList}
                                                handleNumberPlate={handleNumberPlate}
                                                numberPlate={numberPlate}
                                                isDelearshipLogo={isDelearshipLogo}
                                                isBackgroundBlur={isBackgroundBlur}
                                                handleColorEnhancement={handleColorEnhancement}
                                                checkColorEnhancement={checkColorEnhancement}
                                                handleWindowCorrection={handleWindowCorrection}
                                                checkWindowCorrection={checkWindowCorrection}
                                                isLoggedIn={props.isLoggedIn}
                                                handleColorBackground={handleColorBackground}
                                                marketPlaceList={marketPlaceList}
                                                setMarketId={setMarketId}
                                                marketId={marketId}
                                                frontendData={props.frontendData}
                                                imageProcessing={creditVerify}
                                                checkShadow={checkShadow}
                                                handleCheckShadow={handleCheckShadow}
                                                handleMarketId={handleMarketId}
                                                categoryType={props.categoryType}
                                                applyType={applyType}
                                                setApplyType={setApplyType}
                                                checkBodyReflection={checkBodyReflection}
                                                setCheckBodyReflection={setCheckBodyReflection}
                                                setCheckBrightness={setCheckBrightness}
                                                setCheckTint={setCheckTint}
                                                setCheckBlur={setCheckBlur}
                                                handleNumberPlateLogo={handleNumberPlateLogo}
                                                isBulk={props.isBulk}
                                                handleImageModalInImageSection = {handleImageModalInImageSection}
                                                shadowType = {shadowType}
                                                handleShadowType = {handleShadowType}
                                                applyShadow = {applyShadow}
                                                setApplyShadow = {setApplyShadow}
                                                prodCatId= {props.prodCatId}
                                                seeThrough={seeThrough}
                                                setSeeThrough={setSeeThrough}
                                            />

                                        </div>
                                    }

                                </div>
                            </div>
                        </section>
                        {/* //Upload Automobile Photo Optmizer */}

                        <BackgroundListModal
                            handleBackground={handleBackground}
                            handleBackgroundList={handleBackgroundList}
                            isLoggedIn={props.isLoggedIn}
                            hideList={hideList}
                            showBackgroundList={showBackgroundList}
                            handleCarsBgList={handleCarsBgList}
                            handleCarsFavList={handleCarsFavList}
                            bgList={bgList}
                            favBgList={favBgList}
                            fileList={props.fileList}
                            backgroundId={backgroundId}
                            imageProcessing={creditVerify}
                            applyType={applyType}
                            setShowBackgroundList={setShowBackgroundList}
                        />

                    </div>
                    <ProjectNameModal
                        showProjectNameModal={showProjectNameModal}
                        handleProjectNameModal={handleProjectNameModal}
                        handleProjectName={handleProjectName}
                        project_name={projectName}
                        projectNameExists={projectNameExists}
                    />

                    <UploadLimitModal
                        maxUpload={props.maxUpload}
                        emptyMultipleFileArray={props.emptyMultipleFileArray}
                    />

                    <BulkCreditModal
                        showBulkCreditModal={showBulkCreditModal}
                        handleBulkCreditModal={handleBulkCreditModal}
                        notEnoughCreditModal={notEnoughCreditModal}
                        enoughCreditModal={enoughCreditModal}
                        zeroCreditModal={zeroCreditModal}
                        hitUploadAPI={hitUploadAPI}
                        fileList={props.fileList}
                        availableCredit={props.availableCredit}
                        getUserCredit={props.getUserCredit}
                        chargedFeature={chargedFeature}
                    />

                    <RefundModal
                        handleRefundModal={handleRefundModal}
                        showRefundModal={showRefundModal}
                        userId={userId}
                        creditUsed={props.usedCredit}
                        availableCredit={props.availableCredit}
                        allotedCredit={props.allotedCredit}
                        refundImgUrl={refundImgUrl}
                        refundOrgUrl={refundOrgUrl}
                        refundImgId={refundImgId}
                        refundSkuId={refundSkuId}
                        updateEditedImageList={props.updateEditedImageList}
                        auth_key={authKey}
                        emailId={emailId}
                        refundNum={refundNum}
                        prodCatId={props.prodCatId}
                    />

                </div>
            )}
        </Dropzone>
    )
}

export default BulkImageProcessing
